import { fetchProductTypeDiscounts } from '@/utils/http/fetchProductTypeDiscounts';
import { Thunk } from '@/redux/types';
import { getProductTypeDiscounts } from '../getters/getProductTypeDiscounts';
import { DiscountsActionTypes, DiscountsSetProductTypeAction } from '../types';

export const initProductTypeDiscounts =
  (productTypeId: string): Thunk<void, DiscountsSetProductTypeAction> =>
  (dispatch, getState) => {
    if (!getProductTypeDiscounts(getState(), productTypeId)) {
      fetchProductTypeDiscounts(productTypeId).then((discountScales) => {
        if (discountScales && discountScales[0]) {
          return dispatch({
            type: DiscountsActionTypes.DISCOUNTS_SET_PRODUCT_TYPE,
            productTypeId,
            discounts: discountScales[0].discounts.filter((d) => d.credit.value > 0),
          });
        }
      });
    }
  };
